import { student } from "../../constants/apiUrl";
import { urlBinder } from "../../helper/url-binder";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { IStudentCarrierPathCurrentOpeningDetails } from "../../models/student/studentCareerPath";


export default new (class StudentCareerPathService {

  public getCurrentOpenings = async (
    pageNumber: number,
    Keyword?: string,
  ): Promise<IApiResponse<IStudentCarrierPathCurrentOpeningDetails>> => {
    try {
      let endPoint = urlBinder(student.STUDENT_CURRENT_OPENING_DETAILS, [pageNumber, Keyword])
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IStudentCarrierPathCurrentOpeningDetails>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IStudentCarrierPathCurrentOpeningDetails>;
      } else {
        throw error;
      }
    }
  };

  public getJobDescription = async (jobCode: string): Promise<IApiResponse<string>> => {
    try {
      let endPoint = urlBinder(student.STUDENT_CURRENT_OPENING_DESCRIPTION, [jobCode])
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<string>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<string>;
      } else {
        throw error;
      }
    }
  };

});



